<!-- 商品详情  -->
<template>
	<div
		class="ui-detail-swiper"
		v-bind:class="{
			'hide-promotion-bottom': ispromotion,
			'has-goods-stock': isStock <= 0
		}"
	>
		<product-info @mbBodytop="getmbBodytop" @reviewtop="getreviewtop"></product-info>
	</div>
</template>

<script>
import ProductInfo from './child/ProductInfo'
import ProductDesc from './child/ProductDesc'
import ProductReview from './child/ProductReview'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {}
  },

  props: ['isStock'],

  components: {
    ProductInfo,
    ProductDesc,
    ProductReview
  },

  computed: {
    ...mapState({
      ispromotion: state => state.goodsdetail.ispromotion
    })
  },

  watch: {},

  mounted () {},

  created () {},

  methods: {
    ...mapMutations({}),
	getmbBodytop:function(top){
		this.$emit('mbBodytop',top);
	},
	getreviewtop:function(top){
		this.$emit('reviewtop',top);
	}
  }
}
</script>

<style lang="scss" scoped>
.ui-detail-swiper {
	position: absolute;
	-webkit-overflow-scrolling: touch;
	width: 100%;
	top: $headerHeight;
	bottom: $footerHeight;
	left: 0;
	right: 0;
	overflow: auto;
	z-index: 0;

	&.hide-promotion-bottom {
		bottom: 0;
	}
}
</style>
